import { DefaultTheme } from "styled-components";

export const darkTheme: DefaultTheme = {
  bgColor: "#3F8CF2",
  cardColor: "white",
  boardColor: "#DADFE9",
};
